module.exports = __webpack_public_path__ + "static/hepatitis-a-fbfa0c3d74a9a44b4fb5ef4d460c8279.png";